import { Config } from './Config';

export default {
    firebase: {
        apiKey: 'AIzaSyATl0uwiGZOs-3jpU2FYaZPtIg6QcBT8xg',
        authDomain: 'aseta-testing.firebaseapp.com',
        databaseURL: 'https://aseta-testing.firebaseio.com',
        projectId: 'aseta-testing',
        storageBucket: 'aseta-testing.appspot.com',
        messagingSenderId: '201465564812',
    },
} as Config;



// WEBPACK FOOTER //
// ./src/env/env.ts